// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3uC6K","title":"AfterBackImages_title__3IAoF","images":"AfterBackImages_images__2OHY-"};